module.exports = __webpack_public_path__ + "img/1585542669.0fa5b9ed.jpg";